import { Text } from "@mantine/core"
import { Trans } from "react-i18next"

import { CertificateCategory } from "@tfg/types/schemas/certificates"

import { CertificateByOrganizationDto } from "~/gen/api"
import { formatDate } from "~/utils/date"

export type ProcessedCertificateDescriptionProps = {
  certificate: CertificateByOrganizationDto
}

export const ProcessedCertificateDescription = ({
  certificate,
}: ProcessedCertificateDescriptionProps) => {
  const isCertificateBounded = certificate.issueDate && certificate.expiryDate

  const isScopeCertificate =
    CertificateCategory.SCOPE === certificate.type.category

  const descriptionValues = {
    type: certificate.type.name,
    issueDate: certificate.issueDate ? formatDate(certificate.issueDate) : "",
    expiryDate: certificate.expiryDate
      ? formatDate(certificate.expiryDate)
      : "",
    productionSiteName: certificate.productionSite.name,
    productionSiteOrganizationName:
      certificate.productionSite.createdBy.organization.name,
    activityName: certificate.processingSteps.join(", "),
  }

  const descriptionComponents = {
    b: <span style={{ fontWeight: "600" }} />,
    activityName: (
      <span
        style={{
          display:
            isScopeCertificate && certificate.processingSteps.length > 0
              ? "block"
              : "none",
        }}
      />
    ),
  }

  return (
    <Text>
      {isCertificateBounded ? (
        <Trans
          ns="certificates"
          i18nKey="modal.form.description.bounded"
          components={descriptionComponents}
          values={descriptionValues}
        />
      ) : (
        <Trans
          ns="certificates"
          i18nKey="modal.form.description.open"
          components={descriptionComponents}
          values={descriptionValues}
        />
      )}
    </Text>
  )
}
